<template>
<tfoot class="mu-tfoot">
  <slot></slot>
</tfoot>
</template>

<script>
export default {
  name: 'mu-tfoot',
  created () {
    this.isTfoot = true
  },
  computed: {
    showCheckbox () {
      return this.$parent.showCheckbox
    }
  }
}
</script>



// WEBPACK FOOTER //
// tfoot.vue?6b0a0f07